import { useState } from "react";
import { Link } from "react-router-dom";
import { Lock, Clock, Ban, ShieldOff } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { InstitutionMark, VerifiedBadge } from "@/components/Brand";
import { api, formatApiError } from "@/lib/api";

const MSG = {
  pending: { icon: Clock, title: "Pedido enviado!", text: "Seu pedido de vínculo está no painel do líder da instituição. Você será liberado assim que aprovado." },
  rejected: { icon: Ban, title: "Pedido não aprovado", text: "A instituição não aprovou sua participação nesta sala." },
  banned: { icon: Ban, title: "Acesso removido", text: "Você foi removido desta sala por um moderador." },
  blocked: { icon: ShieldOff, title: "Perfil bloqueado preventivamente", text: "O Guarda-Costas IA detectou comportamento que viola as regras. Um moderador irá revisar." },
};

export function AccessGate({ room, onUpdate }) {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const state = MSG[room.my_access];

  const request = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/rooms/${room.id}/join-request`, { message });
      onUpdate(data.status);
      toast.success("Pedido enviado ao líder da sala");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen grid place-items-center px-5">
      <img src={room.cover_url} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20 blur-sm" />
      <div className="relative w-full max-w-md rounded-3xl border border-white/10 bg-card/90 p-7 backdrop-blur-xl rise" data-testid="access-gate">
        <div className="flex items-center gap-2 text-sm">
          <InstitutionMark name={room.institution_name} logo={room.institution_logo} color={room.institution_color} />
          <span className="font-bold">{room.institution_name}</span>
          <VerifiedBadge />
        </div>
        <h1 className="mt-5 text-2xl font-extrabold tracking-tight">{room.title}</h1>
        {state ? (
          <div className="mt-5 flex gap-3 rounded-2xl bg-white/5 p-4" data-testid={`access-state-${room.my_access}`}>
            <state.icon className="shrink-0 text-[hsl(var(--gold))]" />
            <div>
              <p className="font-bold">{state.title}</p>
              <p className="text-sm text-muted-foreground">{state.text}</p>
            </div>
          </div>
        ) : (
          <>
            <p className="mt-3 flex items-center gap-2 text-sm text-muted-foreground"><Lock size={14} /> Esta sala exige aprovação da instituição.</p>
            <Textarea className="mt-4" value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Conte de onde você é ou por que quer participar (opcional)" data-testid="join-request-message" />
            <Button onClick={request} disabled={loading} className="mt-4 w-full rounded-full h-11" data-testid="join-request-button">Solicitar participação</Button>
          </>
        )}
        <Link to="/lives" className="mt-5 block text-center text-sm text-muted-foreground hover:text-white" data-testid="access-gate-back">Voltar ao feed</Link>
      </div>
    </div>
  );
}
